import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

class ValueModeSwitch extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { selectedMode, onChange, modes } = this.props;

		return <div className='center'>
			<ToggleButtonGroup type='radio' name='mode' value={selectedMode} onChange={onChange} bsSize='small'>
				{modes && modes.map((x, index) => <ToggleButton key={index} value={x.value} className={selectedMode === x.value ? 'btn-light-grey' : ''}>{x.label}</ToggleButton>)}
			</ToggleButtonGroup>
			<div className='clearfix' />
		</div>;
	}
}

ValueModeSwitch.propTypes = {
	selectedMode: PropTypes.any,
	modes: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.any,
		label: PropTypes.string
	})),
	onChange: PropTypes.func
};

export default ValueModeSwitch;